import { api } from '@/config'
import httpApi from '@/utils/http-api.js'

export default {
  getCompany: () => {
    return httpApi.getDataViaApi({
      url: api.member.company.find
    })
  },
  getBankInformation: () => {
    return httpApi.getDataViaApi({
      url: api.member.bankInformation.find
    })
  },
  getProfile: () => {
    return httpApi.getDataViaApi({
      url: api.member.profile.get,
      auth: false
    })
  }
}
